import { useEffect, useRef, useState } from "react";

export default function LazySection({
    children,
    fallback,
    rootMargin = "250px"
}) {

    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {

        const observer = new IntersectionObserver(

            ([entry]) => {

                if (entry.isIntersecting) {

                    setVisible(true);

                    observer.disconnect();
                }

            },

            {
                rootMargin
            }

        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();

    }, []);

    return (
        <div ref={ref}>
            {visible ? children : fallback}
        </div>
    );

}